import {
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import axios from "axios";
import React, { useCallback, useMemo, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { moveFormatter } from "../../fomatters/BooleanFormatter";
import { dateTimeReportFormatter } from "../../fomatters/DateFormatter";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import Report from "../Report";
import SubGroup from "../SubGroup";
import CheckNumber from "./CheckNumber";
import CheckSelect from "./CheckSelect";
import CheckText from "./CheckText";
import WagerDetails from "./WagerDetails";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() + 6);

const startDateValue = new Date().toISOString().split("T")[0];
const endDateValue = currentDate.toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function WagerFinder() {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const playsOptions = useMemo(
    () => [
      { value: -1, text: "" },
      { value: 0, text: "Side" },
      { value: 1, text: "Total" },
      { value: 2, text: "$-Line" },
    ],
    []
  );

  /**
   * DATES
   */
  const [usePlacedDate, setUsePlacedDate] = useState(1);
  const [useSettledDate, setUseSettledDate] = useState(0);
  const [dateSelection, setDateSelection] = useState("0");
  const handleDateSelectionChange = useCallback((event) => {
    setDateSelection(event.target.value);
    if (event.target.value === "0") {
      setUsePlacedDate(1);
      setUseSettledDate(0);
    } else {
      setUsePlacedDate(0);
      setUseSettledDate(1);
    }
  }, []);

  const [placedDateTo, setPlacedDateTo] = useState(endDateValue);
  const [placedDateFrom, setPlacedDateFrom] = useState(startDateValue);
  const handlePlacedDateChange = useCallback((event) => {
    setPlacedDateFrom(event.target.value);

    const newDate = new Date(event.target.value);
    newDate.setDate(newDate.getDate() + 6);
    setPlacedDateTo(newDate.toISOString().split("T")[0]);
  }, []);

  const [settledDateTo, setSettledDateTo] = useState(endDateValue);
  const [settledDateFrom, setSettledDateFrom] = useState(startDateValue);
  const handleSettledDateChange = useCallback((event) => {
    setSettledDateFrom(event.target.value);

    const newDate = new Date(event.target.value);
    newDate.setDate(newDate.getDate() + 6);
    setSettledDateTo(newDate.toISOString().split("T")[0]);
  }, []);

  const [idPlayer, setIdPlayer] = useState(-1);
  const requestUser = useCallback(
    (currentPlayer) => {
      const url = `${process.env.REACT_APP_API2_URL}/Player/Player_GetInfo?Player=${currentPlayer}&IdUser=${userInfo.userId}`;
      axios
        .get(url)
        .then((response) => response.data)
        .then((data) => {
          setIdPlayer(data?.IdPlayer ?? -1);
        });
    },
    [userInfo]
  );

  /**
   * WAGER FILTERS
   */
  const [player, setPlayer] = useState("");
  const onPlayerChange = useCallback((p) => setPlayer(p), []);
  const onPlayerBlur = useCallback(() => {
    if (player) requestUser(player);
    else setIdPlayer(-1);
  }, [player, requestUser]);

  const [idAgent, setIdAgent] = useState(-1);
  const onIdAgentChange = useCallback((p) => setIdAgent(Number(p)), []);

  const [idProfile, setIdProfile] = useState(-1);
  const onIdProfileChange = useCallback((p) => setIdProfile(Number(p)), []);

  const [idLineType, setIdLineType] = useState(-1);
  const onIdLineTypeChange = useCallback((p) => setIdLineType(Number(p)), []);

  const [idGrouping, setIdGrouping] = useState(-1);
  const onIdGroupingChange = useCallback((p) => setIdGrouping(Number(p)), []);

  const [idSport, setIdSport] = useState("");
  const onIdSportChange = useCallback((p) => setIdSport(p), []);

  const [teamName, setTeamName] = useState("");
  const onTeamNameChange = useCallback((p) => setTeamName(p), []);

  const [period, setPeriod] = useState(-1);
  const onPeriodChange = useCallback((p) => setPeriod(Number(p)), []);

  const [idUser, setIdUser] = useState(-1);
  const onIdUserChange = useCallback((p) => setIdUser(p), []);

  const [pitcher, setPitcher] = useState("");
  const onPitcherChange = useCallback((p) => setPitcher(p), []);

  const [play, setPlay] = useState("");
  const onPlayChange = useCallback((p) => setPlay(p), []);

  const [wagerType, setWagerType] = useState(-1);
  const onWagerTypeChange = useCallback((p) => setWagerType(Number(p)), []);

  const [ip, setIp] = useState("");
  const onIpChange = useCallback((p) => setIp(p), []);

  const [ticketNumber, setTicketNumber] = useState(-1);
  const onTicketNumberChange = useCallback((p) => setTicketNumber(p), []);

  const [callId, setCallId] = useState(-1);
  const onCallIdChange = useCallback((p) => setCallId(p), []);

  const [phoneLine, setPhoneLine] = useState(-1);
  const onPhoneLineChange = useCallback((p) => setPhoneLine(p), []);

  const [wagerStatus, setWagerStatus] = useState(0);
  const onWagerStatusChange = useCallback((event) => {
    setWagerStatus(Number(event.target.value));
  }, []);

  const [openPlay, setOpenPlay] = useState(0);
  const onOpenPlayChange = useCallback((event) => {
    setOpenPlay(Number(event.target.value));
  }, []);

  /**
   * ROW SELECTION
   */
  const [selectedWager, setSelectedWager] = useState({});
  const onRowClick = useCallback((row) => {
    setSelectedWager(row);
  }, []);

  return (
    <div className="flex flex-col w-full gap-4 p-4 h-max">
      <SubGroup title="Settings" className="grid grid-cols-4 gap-4 p-4">
        <div className="flex flex-col gap-4">
          <RadioGroup
            label
            value={dateSelection}
            onChange={handleDateSelectionChange}
            className="flex flex-col gap-4"
          >
            <div className="flex gap-1">
              <FormControlLabel
                className="w-20"
                control={<Radio value="0" size="small" color="primary" />}
                label="Placed Date"
                labelPlacement="end"
              />
              <TextField
                required
                className="flex-1"
                variant="outlined"
                label="From"
                type="date"
                size="small"
                value={placedDateFrom}
                onChange={handlePlacedDateChange}
                InputLabelProps={{ shrink: true }}
              />
            </div>
            <div className="flex gap-1">
              <FormControlLabel
                className="w-20"
                control={<Radio value="1" size="small" color="primary" />}
                label="Settled Date"
                labelPlacement="end"
              />
              <TextField
                required
                className="flex-1"
                variant="outlined"
                label="From"
                type="date"
                size="small"
                value={settledDateFrom}
                onChange={handleSettledDateChange}
                InputLabelProps={{ shrink: true }}
              />
            </div>
          </RadioGroup>
          <CheckText
            name="Player"
            onChange={onPlayerChange}
            onBlur={onPlayerBlur}
          />
          <CheckSelect
            name="Agent"
            requestValue="IdAgent"
            requestText="Agent"
            requestPath={`/Agent/Agent_GetList2Result?idUser=${userInfo.userId}`}
            onChange={onIdAgentChange}
          />
          <CheckSelect
            name="User"
            requestValue="IdUser"
            requestText="LoginName"
            requestPath="/User/GetUsers"
            onChange={onIdUserChange}
          />
          <CheckText name="IP" onChange={onIpChange} />
        </div>
        <div className="flex flex-col gap-4">
          <TextField
            required
            variant="outlined"
            label="To"
            type="date"
            size="small"
            disabled
            value={placedDateTo}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            required
            variant="outlined"
            label="To"
            type="date"
            size="small"
            disabled
            value={settledDateTo}
            InputLabelProps={{ shrink: true }}
          />
          <CheckNumber name="Ticket" onChange={onTicketNumberChange} />
          <CheckNumber name="Call ID" onChange={onCallIdChange} />
          <CheckNumber name="Phone" onChange={onPhoneLineChange} />
        </div>
        <div className="flex flex-col gap-4">
          <CheckSelect
            name="Profile"
            requestValue="IdProfile"
            requestText="ProfileName"
            requestPath="/Player/GetPlayerProfile"
            onChange={onIdProfileChange}
          />
          <CheckSelect
            name="Line Type"
            requestValue="idLineType"
            requestText="description"
            requestPath="/LineType/GetLineTypes"
            onChange={onIdLineTypeChange}
          />
          <CheckSelect
            name="Group"
            requestValue="IdGrouping"
            requestText="GroupName"
            requestPath="/Player/Grouping_GetList"
            onChange={onIdGroupingChange}
          />
          <CheckSelect
            name="Sport"
            requestValue="IdSport"
            requestText="SportName"
            requestPath="/Player/GetSports"
            onChange={onIdSportChange}
            defaultValue=""
          />
          <CheckSelect
            name="Team"
            disabled={!idSport}
            requestValue="TeamName"
            requestText="LongName"
            requestPath={`/Game/Team_GetList?idSport=${idSport}`}
            onChange={onTeamNameChange}
            defaultValue=""
          />
          <CheckSelect
            name="Period"
            disabled={!idSport}
            requestValue="NumberOfPeriod"
            requestText="PeriodDescription"
            requestPath={`/Game/Period_GetList?idSport=${idSport}`}
            onChange={onPeriodChange}
            defaultValue=""
          />
        </div>
        <div className="flex flex-col gap-4">
          <CheckSelect
            name="Pitcher"
            requestValue="IdPitcher"
            requestText="PitcherName"
            requestPath="/Game/Pitcher_GetList"
            onChange={onPitcherChange}
            defaultValue=""
          />
          <CheckSelect
            name="Play"
            requestValues={playsOptions}
            onChange={onPlayChange}
          />
          <CheckSelect
            name="Wager Type"
            requestValue="WagerType"
            requestText="Description"
            requestPath="/Wager/WagerType_GetNameList"
            onChange={onWagerTypeChange}
          />
          <SubGroup title="Wager Status" className="items-center">
            <RadioGroup
              label
              value={wagerStatus}
              onChange={onWagerStatusChange}
              row
            >
              <FormControlLabel
                control={<Radio value={0} size="small" color="primary" />}
                label="Both"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value={1} size="small" color="primary" />}
                label="Graded"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value={2} size="small" color="primary" />}
                label="Ungraded"
                labelPlacement="end"
              />
            </RadioGroup>
          </SubGroup>
          <SubGroup title="Activity" className="items-center">
            <RadioGroup label value={openPlay} onChange={onOpenPlayChange} row>
              <FormControlLabel
                control={<Radio value={0} size="small" color="primary" />}
                label="All"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value={1} size="small" color="primary" />}
                label="No"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value={2} size="small" color="primary" />}
                label="Yes"
                labelPlacement="end"
              />
            </RadioGroup>
          </SubGroup>
        </div>
      </SubGroup>
      <Report
        title="Wager Finder"
        onRowClick={onRowClick}
        getUrl={() => "/Wager/WagerTracker_GetWagers"}
        getParams={({ userId }) => ({
          Graded: wagerStatus,
          UsePlacedDate: usePlacedDate,
          PlacedDateFrom: usePlacedDate ? placedDateFrom : null,
          PlacedDateTo: usePlacedDate ? placedDateTo : null,
          UseSettledDate: useSettledDate,
          SettledDateFrom: useSettledDate ? settledDateFrom : null,
          SettledDateTo: useSettledDate ? settledDateTo : null,
          IdPlayer: idPlayer,
          IdAgent: idAgent,
          IdProfile: idProfile,
          IdLineType: idLineType,
          IdGrouping: idGrouping,
          userId: idUser,
          PhoneLine: phoneLine,
          TicketNumber: ticketNumber,
          WagerType: wagerType,
          IdSport: idSport,
          Play: play,
          Period: period,
          CallID: callId,
          TeamName: teamName,
          Pitcher: pitcher,
          IP: ip,
          OpenPlay: openPlay,
          OrderBy: 0,
          IdUser: Number(userId),
        })}
      >
        <TableHeaderColumn dataSort dataField="TicketNumber" isKey>
          Ticket #
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="LoginName">
          User
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="PlacedDate"
          dataFormat={dateTimeReportFormatter}
          width="200"
        >
          Placed Date
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="LineType">
          Line Type
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="ProfileName">
          Profile
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="Player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="CompleteDescription" width="250">
          Description
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="RiskAmount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Risk
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="WinAmount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Win
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="PhoneLine">
          Station
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="IP">
          IP
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="HGraded"
          dataFormat={moveFormatter}
        >
          Graded
        </TableHeaderColumn>
      </Report>
      <WagerDetails
        WagerId={selectedWager.TicketNumber}
        Graded={selectedWager.HGraded}
        Open={selectedWager}
        onClose={() => setSelectedWager({})}
      />
    </div>
  );
}

export default WagerFinder;
